import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';

const THEMES = ['light', 'dark'];

export const applyColorTheme = theme => {
  THEMES.forEach(themeName => {
    document.body.classList.toggle(themeName, theme === themeName);
    document.documentElement.classList.toggle(themeName, theme === themeName);
  });

  document.body.dataset.theme = theme;
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.setProperty('color-scheme', theme);
};

export const setColorTheme = isOSOnDarkMode => {
  const selectedColorScheme =
    LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'auto';
  const resolvedTheme =
    (selectedColorScheme === 'auto' && isOSOnDarkMode) ||
    selectedColorScheme === 'dark'
      ? 'dark'
      : 'light';

  applyColorTheme(resolvedTheme);
};
